import { useEffect } from "react";
import "./style/RelifePlans.css";
import { NavLink, Link } from "react-router-dom";

export default function RelifePlans() {
  return (
    <>
      <section className="audio-section">
        <div className="audio-inner">
          <div>
            <div
              className="l-rule"
              style={{ marginLeft: "auto", marginRight: "auto" }}
            />
            <span className="l-eyebrow" style={{ textAlign: "center" }}>
              A small example
            </span>
          </div>
          <h2 className="audio-headline">
            A small example of what Introspecta
            {/* <br /> */} <em>feels like.</em>
          </h2>
          <div className="preview-card" data-testid="card-reflection-preview">
            <div className="preview-card__row">
              <span className="preview-card__label">Question</span>
              <p className="preview-card__question">
                When pressure builds inside you, what do you usually do first?
              </p>
            </div>

            <div className="preview-card__divider" />

            <div className="preview-card__row">
              <span className="preview-card__label">Your answer</span>
              <p className="preview-card__answer">
                "I act normal, but inside I feel tense all day."
              </p>
            </div>

            <div className="preview-card__divider" />

            <div className="preview-card__row">
              <span className="preview-card__label preview-card__label--gold">
                Reflection
              </span>
              <p className="preview-card__reflection-lead">
                The hardest pressure is the one nobody sees.
              </p>
              <p className="preview-card__reflection">
                You keep moving, answering, working, smiling, functioning, but
                inside something never fully relaxes. It can feel like your body
                is present, while your mind is quietly bracing for the next
                problem.
              </p>
              <p className="preview-card__reflection">
                That may mean you learned that staying composed felt safer than
                being honest about the pressure.
              </p>
              <p className="preview-card__reflection-close">
                Two small things to notice today:
                <br />
                <em>
                  How much energy you do you spend managing yourself so nobody
                  notices you are not okay?
                  <br />
                  And what are you afraid might happen if people saw how much
                  you are really carrying?
                </em>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
